import { Box, Typography, IconButton, Modal } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import CardSvg from "@/assets/svg/CardSvg";
import { styles } from "./stylesBuyModal";
import { useSwapMutation } from "@/store/api/walletApi";
import { useState } from "react";
import { FetchBaseQueryError } from "@reduxjs/toolkit/query";
import CustomToast from "@/components/UI/CustomToast/CustomToast";

interface BuyModalProps {
  onClose: () => void;
}

const BuyModal = ({ onClose }: BuyModalProps) => {
  const [swap, { isLoading: swapping }] = useSwapMutation();
  const [showInput, setShowInput] = useState(false);
  const [amount, setAmount] = useState("100");
  const [toast, setToast] = useState<{ message: string; success: boolean } | null>(null);
  const handleSubmitAmount = () => {
    if (!amount) return;
    setShowInput(false);
  };

  const BuyWithUsdt = async () => {
    const value = Number(amount);
    if (!value || isNaN(value) || value <= 0) return;

    try {
      await swap({
        amount: value.toString(),
        currency: "USD",
        swap_out: "USDT",
        swap_in: "BTC",
      }).unwrap();

      setToast({ message: "Successfully swapped USDC to BTC!", success: true });
      onClose();
    } catch (err) {
      console.error("Swap failed", err);

      let message = "Failed to swap. Please try again.";
      const error = err as FetchBaseQueryError & { data?: { message?: string } };
      if (error?.data && typeof error.data === "object" && "message" in error.data) {
        message = (error.data as any).message ?? message;
      }

      setToast({ message, success: false });
    }
  };
  const handleCard = () => {
    // if (!walletAddress) {
    //   console.error("Missing walletAddress");
    //   return;
    // }

    const params = new URLSearchParams({
      coinType: "BTC",
      returnUrl: `${window.location.href}`,
      fiatType: "USD",
      fiatAmount: "100",
      // walletAddress: "wallet_address_here",
    });

    const url = `https://speedwallet.banxa.com/?${params.toString()}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };
  return (
    <Modal open={true} sx={styles.modalOverlay} onClick={onClose}>
      <Box sx={styles.modal} onClick={(e) => e.stopPropagation()}>
        {toast && (
          <CustomToast
            message={toast.message}
            success={toast.success}
            onClose={() => setToast(null)}
          />
        )}
        <Box sx={styles.header}>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
        <Box sx={styles.content}>
          <Typography sx={styles.title}>Buy BTC</Typography>
          <Typography sx={styles.subtitle}>
            Please select the payment method you'd like to use to buy BTC for your wallet.
          </Typography>

          <Box sx={styles.methodBox} onClick={handleCard}>
            <CardSvg />
            <Typography sx={styles.methodText}>CreditCard/Debit Card</Typography>
            <ArrowForwardIosIcon fontSize="small" />
          </Box>

          <Box sx={styles.methodBox}>
            <CardSvg />
            <Typography sx={styles.methodText}>USDC</Typography>
            {showInput ? (
              <Box sx={{ display: "flex", alignItems: "center", gap: "4px" }}>
                <Typography>$</Typography>
                <input
                  type="number"
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                  onBlur={handleSubmitAmount}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      handleSubmitAmount();
                    }
                  }}
                  autoFocus
                  style={{
                    border: "none",
                    outline: "none",
                    fontFamily: "Inter",
                    fontSize: "14px",
                    width: "60px",
                    background: "transparent",
                  }}
                />
              </Box>
            ) : (
              <Typography
                sx={{ ...styles.amount, cursor: "pointer" }}
                onClick={() => setShowInput(true)}
              >
                ${amount}
              </Typography>
            )}
            <ArrowForwardIosIcon
              fontSize="small"
              onClick={swapping ? undefined : BuyWithUsdt}
              sx={{ cursor: swapping ? "default" : "pointer", opacity: swapping ? 0.6 : 1 }}
            />
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default BuyModal;
